import { normalizeInfiniteQueryData } from '@gasbi/shared/common/features/utils';
import {
  ServiceEmployee,
  extendWithServiceEmployees,
} from '@gasbi/shared/web/ServiceEmployees';

import { employeesApi } from '@/features/employees/employeesApi';
import { FiltersGrid, Pagination } from '@/features/types';
import { infiniteQueryOptions } from '@/features/utils';

// The service-employee endpoints are shared by Supply Admin and Distribution Admin (GSB-8222); the
// hooks keep the names the app uses.
export const serviceEmployeesApi = extendWithServiceEmployees(employeesApi);

export { CREATE_SERVICE_EMPLOYEES_CACHE_KEY } from '@gasbi/shared/web/ServiceEmployees';

export const {
  useGetServiceEmployeesQuery,
  useGetServiceEmployeeQuery,
  useCreateServiceEmployeesMutation,
  useUpdateServiceEmployeeMutation,
  useActivateServiceEmployeeMutation,
  useDeactivateServiceEmployeeMutation,
  useUpdateServiceEmployeeAccessMutation,
} = serviceEmployeesApi;

type ServiceEmployeesPageArg = FiltersGrid & {
  serviceId: string;
  organizationId: string;
};

// One service's employees of an organization page by page, filtered as a picker asks (gridify).
const serviceEmployeesPagesApi = employeesApi.injectEndpoints({
  endpoints: builder => ({
    getServiceEmployeesI: builder.infiniteQuery<
      ServiceEmployee[],
      ServiceEmployeesPageArg,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({
        queryArg: { serviceId, organizationId, ...params },
        pageParam,
      }) => ({
        url: `/services/${serviceId}/organizations/${organizationId}`,
        params: { ...params, ...pageParam },
      }),
      transformResponse: ({ items }: { items: ServiceEmployee[] }) => items,
      providesTags: () => ['Employees'],
    }),
  }),
});

export const useGetServiceEmployeesInfiniteQuery = normalizeInfiniteQueryData(
  serviceEmployeesPagesApi.useGetServiceEmployeesIInfiniteQuery,
);
